// src/components/printStyles.js
import { createGlobalStyle } from "styled-components";

export const PrintStyles = createGlobalStyle`

/* -------------------------------
   SCREEN MODE
--------------------------------*/
.print-only { display: none !important; }
.no-print { display: block !important; }


/* -------------------------------
   PRINT MODE
--------------------------------*/
@media print {

  html, body, #root {
    background: #FFFFFF !important;
    color: #191B27 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-family: "Montserrat", sans-serif !important;
  }

  /* Hide everything except print elements */
  .no-print, .no-print * {
    display: none !important;
    visibility: hidden !important;
  }

  .print-only {
    display: block !important;
    visibility: visible !important;
  }

  /* Page Setup */
  @page {
    size: 8.5in 11in;
    margin: 0.25in !important;
  }

.print-page {
  width: 100% !important;
  padding: 0 8px !important;   /* ⬅️ KEY FIX */
  margin: 0 !important;
  box-sizing: border-box !important;
  overflow: visible !important;
}


  /* ----------------------------------
       HEADER
  ----------------------------------*/
  .print-header {
    display: grid !important;
    grid-template-columns: 1fr 2fr 1fr !important;
    align-items: center !important;
    border-bottom: 1px solid #FFFFFF !important;
    padding: 4px 0 !important;
    margin-bottom: 8px !important;
  }
.ph-logo {
  width: 140px !important;
  margin-left: 6px !important;

  display: block !important;
  align-self: center !important;

  position: relative !important;
  top: -2px !important;   /* ⬅️ optical vertical alignment */

  content: url("/PRY_Logo_Light.png") !important;
}

/* ================================
   LOGO OFFSET FOR PAGES 2+
================================ */
.print-chart-page .ph-logo {
  margin-top: 18px !important;
}



  .ph-title {
    text-align: center !important;
    font-size: 24px !important;
    font-weight: 700 !important;
  }

  .ph-date {
    text-align: right !important;
    padding-right: 10px !important;
    font-size: 10px !important;
  }

/* Logo-only header for pages 2+ */
.print-logo-only {
  display: flex !important;
  align-items: center !important;
  margin-bottom: 12px !important;
}

.print-logo-only .ph-logo {
  width: 140px !important; /* same size as page 1 */
}



/* ----------------------------------
   PRINT DATE BAR
----------------------------------*/
.print-date-bar {
  width: 100% !important;
  background: #EAF2FF !important;
  color: #003A8F !important;
  text-align: center !important;

  font-family: "Montserrat", sans-serif !important;
  font-size: 13px !important;
  font-weight: 700 !important;

  padding: 10px 0 !important;
  border-radius: 8px !important;

  margin: 8px 0 16px 0 !important;
}

 

/* ===============================
   MODERN DESCRIPTOR GRID (PRINT)
================================ */

.descriptor-grid-modern {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  gap: 12px !important;
  margin-bottom: 18px !important;
}

.descriptor-box {
  background: #F3F4F6 !important;
  border-radius: 10px !important;
  padding: 12px !important;
  text-align: center !important;
}

.descriptor-title {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #111827 !important;
  margin-bottom: 6px !important;
}

.descriptor-values {
  font-size: 11px !important;
  color: #374151 !important;
  line-height: 1.4 !important;
}

  /* ----------------------------------
       STAT BOXES
  ----------------------------------*/
  .stats-row {
    display: flex !important;
    gap: 8px !important;
    margin-bottom: 32px !important;
  }

/* KPI top accent borders (PRINT ONLY) */
.stat-box {
  position: relative !important;
  overflow: hidden !important;
}

/* Green accent */
.stat-box.border-green::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: #00B388;
}

/* Blue accent */
.stat-box.border-blue::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: #0077C8;
}

/* Extra breathing room before first chart */
.stats-row {
  margin-bottom: 40px !important;
}

  .stat-box {
    flex: 1 !important;
    padding: 6px !important;
    border: 1px solid #2D354A !important;
    border-radius: 6px !important;
    text-align: center !important;
    background: #FFF !important;
  }

 .stat-value {
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: -0.02em !important;
}

.stat-label {
  font-size: 9px !important;
  font-weight: 600 !important;
  letter-spacing: 0.08em !important;
}

  .stat-sub     { font-size: 8px !important; opacity: .8 !important; }


  /* ----------------------------------
       CHARTS WRAPPER
  ----------------------------------*/
  .print-charts-wrapper {
    width: 100% !important;
  }

/* ----------------------------------
   CHART TITLE STYLING (PRINT)
----------------------------------*/
.print-chart-title {
  background: #F3F4F6 !important;
  color: #191B27 !important;
  font-family: "Montserrat", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;

  padding: 8px 12px !important;
  border-radius: 6px !important;

  margin-bottom: 8px !important;
  text-align: center !important;
}

/* CHART TITLE CONTAINER */
.print-chart-title {
  background: #F3F4F6 !important;
  padding: 10px 14px !important;
  border-radius: 6px !important;
  width: 100% !important;
  box-sizing: border-box !important;
  text-align: center !important;
  margin-bottom: 12px !important;
}




  /* ----------------------------------
       CHART PAGES
  ----------------------------------*/
.print-chart-page {
  page-break-after: always !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;   /* ✅ vertical centering */
  gap: 60px !important;
  min-height: calc(11in - 1.5in) !important; /* ✅ usable page height */
}

/* ================================
   MULTI-CHART PAGES (2 charts)
================================ */
.multi-chart-page {
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  gap: 60px !important;
}

/* ================================
   SINGLE-CHART PAGES (1 chart)
================================ */
.single-chart-page {
  display: block !important;
}

.single-chart-page .print-chart {
  margin-top: 24px !important;
}



.print-chart-page:last-child {
  page-break-after: auto !important;
}



  /* First page - charts need to be smaller to fit with header/stats */
  .print-chart-page-first {
    page-break-after: always !important;
  }

.print-chart-page-first {
  justify-content: flex-start !important;
  min-height: auto !important;
}


.print-chart-page-first:last-child {
  page-break-after: auto !important;
}

  .print-chart-page-first .print-chart {
    height: auto !important;
  }

  .print-chart-page-first .print-chart-container {
    height: auto !important;
    max-height: 280px !important;
  }

  /* Regular chart pages (not first) */
  .print-chart-page:not(.print-chart-page-first) .print-chart-container {
    height: auto !important;
    max-height: 380px !important;
  }

  .print-chart {
    width: 100% !important;
    page-break-inside: avoid !important;
  }

.print-chart-container {
  width: 100% !important;
  border-radius: 8px !important;
  display: block !important;
  overflow: visible !important;
  padding-top: 2px !important;
}


  /* ----------------------------------
       RECHARTS OVERRIDES
  ----------------------------------*/


/* ----------------------------------
   LIGHTEN GRIDLINES (PRINT)
----------------------------------*/
.recharts-cartesian-grid-horizontal line {
  stroke: #E5E7EB !important;
  stroke-width: 1 !important;
}

/* ----------------------------------
   AXIS LABEL TYPOGRAPHY (PRINT)
----------------------------------*/
.recharts-text {
  font-family: "Montserrat", sans-serif !important;
  font-size: 10px !important;
  fill: #4B5563 !important;
}

    .recharts-wrapper {
    width: 100% !important;
    height: 100% !important;
    display: block !important;
  }

  .recharts-surface {
    width: 100% !important;
    height: 100% !important;
    overflow: visible !important;
    background: #FFFFFF !important;
  }

  /* Disable animations */
  .recharts-layer,
  .recharts-bar,
  .recharts-line,
  .recharts-area,
  .recharts-cartesian-grid {
    animation: none !important;
    transition: none !important;
  }

  /* Hide interactive UI */
  button, input, select {
    display: none !important;
  }

  /* SVG visibility */
  svg {
    overflow: visible !important;
    display: block !important;
  }

  svg * {
    visibility: visible !important;
  }

  /* Chart card print styling */
  .chart-print-wrapper {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* FORCE white background on all chart containers */
  .print-chart-container > div {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
  }
  
  .print-chart-container > div > div {
    background-color: #FFFFFF !important;
    background: #FFFFFF !important;
  }

  /* ----------------------------------
     FORCE WHITE SVG BACKGROUND (KEY FIX)
  ---------------------------------- */

  /* SVG root surface */
  .recharts-surface > rect:first-child {
    fill: #FFFFFF !important;
  }

  /* Fallback for any dark rect fills */
  .recharts-surface rect[fill="#2D354A"],
  .recharts-surface rect[fill="#191B27"] {
    fill: #FFFFFF !important;
  }

  /* ----------------------------------
     REMOVE BOTTOM HORIZONTAL LINE
  ---------------------------------- */

  hr {
    display: none !important;
    border: none !important;
    height: 0 !important;
  }

  .print-page,
  .print-charts-wrapper,
  .print-chart-page,
  .print-chart {
    border-bottom: none !important;
  }

  .print-page::before,
  .print-page::after {
    content: none !important;
    display: none !important;
  }
}
`;

